export default "__VITE_ASSET__D28fQypZ__"